import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import congratulationStar from "../../asset/images/certificates/congratulation-star.svg";
import certificate1 from "../../asset/images/certificates/certificate-first.jpg";
import certificate2 from "../../asset/images/certificates/certificate-second.jpg";
import certificate3 from "../../asset/images/certificates/certificate-third.jpg";

function Completed(){

    const certificateSlider = {
        dots: false,
        arrows: true,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,

        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
            },
        },
        ],
    }
    
    return(

        <div className="card-box">
                        <div className="card-title">
                            <h2>Completed</h2>
                        </div>
                        <Slider {...certificateSlider} className="certificate-card-slider">
                            <div className="">
                                <div className="certificate-slider-item">
                                    <div className="d-flex flex-column align-items-center">
                                        <span className="certificate-name">POSP Life Insurance - IRDAI</span>
                                        <span className="certificate-congrats-name">
                                            Congratulations!
                                            <img src={congratulationStar}
                                                alt="congratulation-star" className="certificate-congrats-img" />
                                        </span>
                                    </div>

                                    <img src={certificate1} alt="certificate-first"
                                        className="certificate-slider-img" />
                                    <div className="d-flex justify-content-between align-items-center">
                                        <a href="/" className="certificate-view">View
                                            Certificate
                                        </a>
                                        <a href="asset/images/certificates/congratulation-star.svg" download="">
                                            <span className="icon-file-download"></span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="certificate-slider-item">
                                    <div className="d-flex flex-column align-items-center">
                                        <span className="certificate-name">POSP Life Insurance - IRDAI</span>
                                        <span className="certificate-congrats-name">
                                            Congratulations!
                                            <img src={congratulationStar}
                                                alt="congratulation-star" className="certificate-congrats-img" />
                                        </span>
                                    </div>
                                    <img src={certificate2} alt="certificate-second"
                                        className="certificate-slider-img" />
                                    <div className="d-flex justify-content-between align-items-center">
                                        <a href="/" className=" certificate-view">View
                                            Certificate
                                        </a>
                                        <a href="asset/images/certificates/congratulation-star.svg" download="">
                                            <span className="icon-file-download"></span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="certificate-slider-item">
                                    <div className="d-flex flex-column align-items-center">
                                        <span className="certificate-name">POSP Life Insurance - IRDAI</span>
                                        <span className="certificate-congrats-name">
                                            Congratulations!
                                            <img src={congratulationStar}
                                                alt="congratulation-star" className="certificate-congrats-img" />
                                        </span>
                                    </div>
                                    <img src={certificate3} alt="certificate-third"
                                        className="certificate-slider-img" />
                                    <div className="d-flex justify-content-between align-items-center">
                                        <a href="/" className=" certificate-view">View
                                            Certificate
                                        </a>
                                        <a href="asset/images/certificates/congratulation-star.svg" download="">
                                            <span className="icon-file-download"></span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="certificate-slider-item">
                                    <div className="d-flex flex-column align-items-center">
                                        <span className="certificate-name">POSP Life Insurance - IRDAI</span>
                                        <span className="certificate-congrats-name">
                                            Congratulations!
                                            <img src={congratulationStar}
                                                alt="congratulation-star" className="certificate-congrats-img" />
                                        </span>
                                    </div>
                                    <img src={certificate2} alt="certificate-second"
                                        className="certificate-slider-img" />
                                    <div className="d-flex justify-content-between align-items-center">
                                        <a href="/" className="certificate-view">View
                                            Certificate
                                        </a>
                                        <a href="asset/images/certificates/congratulation-star.svg" download="">
                                            <span className="icon-file-download"></span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="certificate-slider-item">
                                    <div className="d-flex flex-column align-items-center">
                                        <span className="certificate-name">POSP Life Insurance - IRDAI</span>
                                        <span className="certificate-congrats-name">
                                            Congratulations!
                                            <img src={congratulationStar}
                                                alt="congratulation-star" className="certificate-congrats-img" />
                                        </span>
                                    </div>
                                    <img src={certificate1} alt="certificate-first"
                                        className="certificate-slider-img" />
                                    <div className="d-flex justify-content-between align-items-center">
                                        <a href="/" className="certificate-view">View
                                            Certificate
                                        </a>
                                        <a href="asset/images/certificates/congratulation-star.svg" download="">
                                            <span className="icon-file-download"></span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </Slider>

                    </div>
    )
}
export default Completed;